/**
 * Витринный тип аудиогида. Не меняет маршрут — только подпись на карточке.
 * first_visit — первый визит в город, scenic — красивая прогулка, historical — исторический.
 */
export enum ReadyRouteGuideTypeEnum {
    FIRST_VISIT = 'first_visit',
    SCENIC = 'scenic',
    HISTORICAL = 'historical',
}
